import React, { useState, useEffect } from "react";
import { Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

const Announcement = ({ announcement, onDismiss }) => {
  const [show, setShow] = useState(true);

  const handleDismiss = () => {
    setShow(false);
    setTimeout(() => {
      onDismiss(announcement._id);
    }, 300); // Wait for animation to complete
  };

  return (
    <Transition
      show={show}
      enter="transition-opacity duration-300"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-300"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className="w-full bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 p-4 mx-auto announcement-wrapper">
        <div className="flex justify-between items-start">
          <div className="flex-1">
            <h3 className="text-sm font-medium text-gray-900">
              {announcement.title}
            </h3>
            <div
              className="mt-1 text-sm text-gray-500"
              dangerouslySetInnerHTML={{ __html: announcement.content }}
            />
            {announcement.ctaLink && (
              <a
                href={announcement.ctaLink}
                className="mt-3 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                target="_blank"
                rel="noopener noreferrer"
              >
                {announcement.ctaText || "Learn More"}
              </a>
            )}
          </div>
          <button
            type="button"
            className="ml-4 text-gray-400 hover:text-gray-500 focus:outline-none"
            onClick={handleDismiss}
          >
            <span className="sr-only">Dismiss</span>
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>
      </div>
    </Transition>
  );
};

export default Announcement;
